export const ProblemSeverityEnum = Object.freeze({
    NoProblem: "NO_PROBLEM",
    SlightProblem: "SLIGHT_PROBLEM",
    ModerateProblem: "MODERATE_PROBLEM",
    MajorProblem: "MAJOR_PROBLEM",
    NotPossible: "NOT_POSSIBLE"
})
